import { settings } from "@/settings"
import { useState } from "react"
export default function SignupForm() {
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    setIsLoading(true)

    // Only make the API call if there's an email
    if (email.length > 0) {
      try {
        await fetch(`${settings.VIBRATO_URL}/api/mailing_list/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: email
          })
        })
      } catch (error) {
        console.error("Failed to add email to mailing list:", error)
        // Continue with redirect even if the API call fails
      }
    }

    setSubmitted(true)
    await new Promise((resolve) => setTimeout(resolve, 500))
    const redirectUrl =
      email.length > 0
        ? `${settings.VIBRATO_FRONTEND_URL}/signup?email=${encodeURIComponent(email)}`
        : `${settings.VIBRATO_FRONTEND_URL}/signup`

    if (window.top) {
      window.top.location.href = redirectUrl
    } else {
      window.location.href = redirectUrl
    }
  }

  return (
    <div className="w-full h-fit bg-transparent flex justify-center">
      <div className="w-[420px] sm:w-[600px]">
        <form className="flex flex-col sm:flex-row gap-5 p-5">
          <label className="relative flex items-center flex-1">
            <div className="w-full">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                onChange={handleEmailChange}
                className="w-full px-4 py-3 pr-12 rounded-[14px] border border-[rgba(136,136,136,0.1)]
                text-[rgba(0,0,0,0.7)] placeholder-gray-400 bg-white font-cabin text-[16px]"
              />
            </div>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="rgb(153, 153, 153)">
                <path d="M12.6875 4.375C12.6875 3.4375 11.9375 2.625 11 2.625H3C2.125 2.625 1.3125 3.4375 1.3125 4.375V9.625C1.3125 10.5625 2.125 11.375 3 11.375H11C11.9375 11.375 12.6875 10.5625 12.6875 9.625V4.375ZM11 4.375L7 6.875L3 4.375H11ZM11 9.625H3V6.125L7 8.625L11 6.125V9.625Z" />
              </svg>
            </div>
          </label>

          <button
            onClick={handleSubmit}
            disabled={isLoading || submitted}
            className="sm:w-[180px] w-full py-3 px-4 rounded-[15px] font-bold text-white
            bg-linear-to-r from-[#3329BA] to-[#C138F2] hover:opacity-90 disabled:opacity-70
            font-readex-pro text-[16px]"
          >
            {isLoading ? "Please wait..." : submitted ? "Success! ✅" : "Start for Free"}
          </button>
        </form>
      </div>
    </div>
  )
}
